<template>
  <div class="im-messages" ref="list">
    <Message
      v-for="message in $store.state.dialog.content"
      :key="message.id"
      :isMine="message.isMine"
      :isForGroup="message.isForGroup"
      :username="message.username"
      :statusText="message.statusText"
      :timestamp="message.time"
      :content="message.text"
      :promoId="message.promoId"
      :promoMessagesCount="message.promoMessagesCount"
      :promoUsersCount="message.promoUsersCount"
      :promoCanShare="message.promoCanShare"
    />
    <div class="im-messages__new-message-btn" v-show="newMessageButtonVisible" @click="scrollToNewMessage">
      <span class="im-messages__new-message-btn__text" v-text="'+' + $store.state.dialog.newMessageCount"></span>
      <svg class="im-messages__new-message-btn__arrow">
        <use xlink:href="#icon-arrow-down"></use>
      </svg>
    </div>
  </div>
</template>

<script>
  import Message from './message/Message.vue';

  let needAutoScrollToBottom = false;
  let autoScrollAfterOpenDialog = true;
  let autoScrollAfterNewMessage = false;
  const offsetForAutoScroll = 50;

  export default {
    name: 'Messages',
    components: {
      Message
    },
    computed: {
      newMessageButtonVisible() {
        return this.$store.state.dialog.newMessageCount ? true : false;
      }
    },
    methods: {
      onStoreBeforeUpdateMessages: function (dialog) {
        autoScrollAfterNewMessage = !dialog.content.length || (this.$refs.list.scrollHeight - this.$refs.list.scrollTop - this.$refs.list.clientHeight) < offsetForAutoScroll;
      },
      onStoreAfterUpdateMessages: function (dialog) {
        if (autoScrollAfterOpenDialog || this.$store.state.dialog.newMessageCount && autoScrollAfterNewMessage) {
          needAutoScrollToBottom = true;
        }
      },
      onStoreOpenDialog: function (dialog) {
        autoScrollAfterOpenDialog = true;
      },
      scrollToNewMessage: function() {
        this.$refs.list.scrollTop = this.$refs.list.scrollHeight;
        this.$store.commit('resetDialogNewMessageCount');
      }
    },
    mounted() {
      autoScrollAfterOpenDialog = true;
      this.$bus.$on('storeBeforeUpdateMessages', this.onStoreBeforeUpdateMessages);
      this.$bus.$on('storeAfterUpdateMessages', this.onStoreAfterUpdateMessages);
      this.$bus.$on('storeOpenDialog', this.onStoreOpenDialog);
    },
    updated() {
      if (needAutoScrollToBottom) {
        needAutoScrollToBottom = false;
        autoScrollAfterOpenDialog = false;
        this.scrollToNewMessage();
      }
    },
    beforeDestroy() {
      this.$bus.$off('storeBeforeUpdateMessages', this.onStoreBeforeUpdateMessages);
      this.$bus.$off('storeAfterUpdateMessages', this.onStoreAfterUpdateMessages);
      this.$bus.$off('storeOpenDialog', this.onStoreOpenDialog);
    }
  };
</script>

<style lang="scss">
  .im-messages {
    padding: 0;
    overflow: hidden;
    overflow-y: auto;
    height: 560px;

    &::-webkit-scrollbar {
      width: 4px;

      &-track {
        background: #FFFFFF;
      }

      &-thumb {
        background: #C6CBD0;
        border-radius: 2px;
      }
    }

    &__new-message-btn {
      position: absolute;
      bottom: 10px;
      right: 10px;
      background: #1588E2;
      color: #ffffff;
      font-size: 14px;
      font-weight: bold;
      padding: 10px 14px;
      cursor: pointer;

      &__text{
        vertical-align: middle;
      }
      &__arrow {
        fill: #ffffff;
        height: 7px;
        width: 12px;
        margin-left: 6px;
        vertical-align: middle;
      }
    }
  }
</style>